import NewThreadPage from 'components/pages/SuggestNewThread';

const NewThread = () => <NewThreadPage />;

export default NewThread;
